import styles from './OrderSummaryCard.module.scss';
import { CartItemBodyProps } from './OrderSummaryCardBody';
import ProgramRegistrationsTable from './ProgramRegistrationsTable';

export default function OrderSummaryCardDetails({
  addOns = [],
  cartItemUuid,
  subprograms = [],
  subtype,
}: Readonly<
  Pick<CartItemBodyProps, 'addOns' | 'cartItemUuid' | 'subprograms' | 'subtype'>
>) {
  return (
    <div
      className={styles.orderSummaryCardDetails}
      data-testid="order-summary-card-details"
    >
      <ProgramRegistrationsTable
        addOns={addOns ?? []}
        cartItemUuid={cartItemUuid}
        subprograms={subprograms}
        subtype={subtype}
      />
    </div>
  );
}
